import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

class ClassificationsService {
  getClassifications({ limit, scheme }) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    const query = [limit ? `limit=${limit}` : '', scheme ? `&scheme=${scheme}` : ''].join('&');

    return ApiService.get(`${Config.api.tender.url}tenders/facets/classifications?${query}`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
}

export const classificationsService = new ClassificationsService();
